// ── All site content in one place — easy to edit ──

export const PHONE = "+919154264353";
export const WHATSAPP_URL = `https://wa.me/919154264353`;
export const MOBILE_URL = "http://localhost:3001/#testimonials";

export const ingredients = [
  {
    emoji: "🥒",
    name: "Karela",
    aka: "Bitter Melon · Momordica charantia",
    desc: "One of Ayurveda's most potent botanicals for metabolic health. Contains charantin and polypeptide-p which mimic insulin activity, helping the body maintain balanced blood glucose levels naturally.",
    benefit: "Regulates Blood Sugar",
  },
  {
    emoji: "🍃",
    name: "Neem",
    aka: "Indian Lilac · Azadirachta indica",
    desc: 'Revered as "The Village Pharmacy," neem\'s powerful flavonoids and glycosides support deep cellular cleansing, liver function, and natural blood purification processes.',
    benefit: "Detox & Purifies Blood",
  },
  {
    emoji: "🌾",
    name: "Methi",
    aka: "Fenugreek · Trigonella foenum-graecum",
    desc: "Rich in soluble fiber and 4-hydroxyisoleucine, Methi seeds slow glucose absorption and improve how cells respond to insulin — supporting healthy post-meal blood sugar levels.",
    benefit: "Improves Insulin Sensitivity",
  },
  {
    emoji: "🫐",
    name: "Amla",
    aka: "Indian Gooseberry · Phyllanthus emblica",
    desc: "Nature's richest source of Vitamin C, Amla is a powerful Rasayana (rejuvenating tonic). It boosts immunity, enhances metabolism, and provides deep antioxidant protection to every cell.",
    benefit: "Immunity & Metabolism",
  },
];

export const benefits = [
  {
    icon: "🩸",
    title: "Manages Blood Sugar",
    desc: "Helps maintain healthy fasting and post-meal glucose levels through multi-pathway support.",
  },
  {
    icon: "🫁",
    title: "Supports Pancreas",
    desc: "Nourishes pancreatic beta cells to support healthy insulin production and release.",
  },
  {
    icon: "⚡",
    title: "Boosts Energy",
    desc: "Better glucose utilization means more stable, sustained energy throughout the day.",
  },
  {
    icon: "🌟",
    title: "Overall Well-being",
    desc: "Holistic formula that supports digestion, liver health, and systemic balance.",
  },
  {
    icon: "🛡️",
    title: "Rich in Antioxidants",
    desc: "High antioxidant content protects cells from oxidative stress linked to metabolic conditions.",
  },
];

export const steps = [
  {
    num: 1,
    title: "Measure Your Dose",
    desc: "Take 1 level teaspoon (approximately 5g) of Diabetic Wellness Powder.",
  },
  {
    num: 2,
    title: "Mix in Warm Water",
    desc: "Stir well into a glass of warm water (200ml) until fully dissolved.",
  },
  {
    num: 3,
    title: "Take Before Meals",
    desc: "Consume 15–30 minutes before main meals for best results.",
  },
  {
    num: 4,
    title: "Twice Daily",
    desc: "Repeat morning and evening, or as advised by your healthcare professional.",
  },
];

export const whyUs = [
  {
    icon: "🌿",
    title: "100% Natural",
    desc: "Only real herbs, zero synthetic additives or fillers.",
  },
  {
    icon: "🚫",
    title: "Chemical Free",
    desc: "No preservatives, no artificial colors, no hidden chemicals.",
  },
  {
    icon: "✅",
    title: "Safe & Effective",
    desc: "Rooted in traditional Ayurvedic knowledge, safe for long-term use.",
  },
  {
    icon: "🇮🇳",
    title: "Made in India",
    desc: "Proudly crafted in India for your family's daily wellness.",
  },
  {
    icon: "💯",
    title: "Satisfaction Guarantee",
    desc: "We stand behind every pack with a 100% satisfaction promise.",
  },
];

export const testimonials = [
  {
    avatar: "👨",
    stars: 5,
    text: '"My father has been using this powder for 2 months now. His morning sugar readings have stabilized noticeably. We\'re really happy with this natural approach!"',
    name: "Ramesh K.",
    location: "Hyderabad, Telangana",
  },
  {
    avatar: "👩",
    stars: 5,
    text: '"I was skeptical at first, but after seeing results in 3 weeks, I ordered for my whole family. The bitter melon-neem combination is truly powerful. Highly recommend!"',
    name: "Priya S.",
    location: "Kakinada, Andhra Pradesh",
  },
  {
    avatar: "🧓",
    stars: 5,
    text: '"What I appreciate most is that it\'s completely natural — no chemicals, no side effects. I feel more energetic and my doctor has noticed improvement in my test results too."',
    name: "Venkat Rao",
    location: "Vijayawada, AP",
  },
];

export const detoxReviews = [
  {
    avatar: "🌿",
    stars: 5,
    text: '"The Detox Powder gave me a clean, energized feeling in just one week. My digestion improved and cravings dropped."',
    name: "Asha R.",
    location: "vizag, Andhra Pradesh",
  },
  {
    avatar: "🍋",
    stars: 5,
    text: '"This detox blend is gentle yet effective. I feel lighter, and my skin looks clearer after daily use."',
    name: "Sonal K.",
    location: "rajamundry, Ap",
  },
  {
    avatar: "🧘",
    stars: 5,
    text: '"I love how natural it tastes and how it helped reset my routine. I now take it every morning."',
    name: "Neha P.",
    location: "eluru, Andhra Pradesh",
  },
  {
    avatar: "🌼",
    stars: 5,
    text: '"One month of Detox Powder and I feel so much more energetic. It helped me stay consistent with my wellness goals."',
    name: "Ritu S.",
    location: "Hyderabad, Telangana",
  },
  {
    avatar: "✨",
    stars: 5,
    text: '"The best detox I have tried. No heavy chemicals, just natural support that actually works."',
    name: "Mira T.",
    location: "amalapuram, Andhra Pradesh",
  },
  {
    avatar: "💧",
    stars: 5,
    text: '"Detox Powder helped me feel less bloated and more active. It now feels like a part of my daily wellness ritual."',
    name: "Geeta N.",
    location: "vijayawada, Andhra Pradesh",
  },
  {
    avatar: "🌱",
    stars: 5,
    text: '"This formula is mild and reliable. After a few weeks I noticed better digestion and improved nightly sleep."',
    name: "Priyanka G.",
    location: "vizag, Andhra Pradesh",
  },
];

export const weightLossReviews = [
  {
    avatar: "🔥",
    stars: 4,
    text: '"The 3-month pack transformed my routine — I lost 7kg the natural way and felt supported all along."',
    name: "Amit V.",
    location: "Tirupati, Andhra Pradesh",
  },
  {
    avatar: "🏃",
    stars: 5,
    text: '"This package gave me steady results. The 3-month plan felt sustainable and I regained confidence."',
    name: "Neeraj S.",
    location: "Kurnool, Andhra Pradesh",
  },
  {
    avatar: "💪",
    stars: 5,
    text: '"I used the 3-month weight loss pack and my energy levels increased while my weight went down slowly but surely."',
    name: "Sana M.",
    location: "Vijayawada, Andhra Pradesh",
  },
  {
    avatar: "🥗",
    stars: 5,
    text: '"The 3-month plan helped me build healthy habits around food and activity. I feel leaner and more balanced."',
    name: "Priyanka D.",
    location: "Anakapalle, Andhra Pradesh",
  },
  {
    avatar: "🌟",
    stars: 5,
    text: '"Highly recommend the 3-month package. It gave consistent support and made the whole weight loss journey easier."',
    name: "Reena K.",
    location: "Visakhapatnam, Andhra Pradesh",
  },
];

export const marqueeItems = [
  "100% Natural Ingredients",
  "No Artificial Colors",
  "No Added Preservatives",
  "Proudly Made in India 🇮🇳",
  "Chemical Free Formula",
  "Traditional Ayurvedic Herbs",
  "Safe & Effective",
  "Daily Wellness Support",
];

export const products = [
  {
    id: "wellness-powder",
    src: "/assets/8.png",
    alt: "Swathi’s Diabetic Wellness Powder pack with premium label",
    title: "Diabetic Powder 250g",
    subtitle: "1 Month Supply",
    price: "₹899 / 1 Month",
    packSize: "250g",
    caption: "Premium diabetic powder for a full month of wellness.",
    details:
      "Contains Karela, Neem, Methi and Amla. Use one level teaspoon in warm water twice daily for best results.",
    available: "In Stock",
  },
  {
    id: "wellness-combo",
    src: "/assets/image1.png",
    alt: "Multiple wellness packs and supplement capsules arranged in a clean product display",
    title: "Diabetic Powder 500g",
    subtitle: "2 Month Supply",
    price: "₹1,499 / 2 Months",
    packSize: "500g",
    caption: "Higher strength formula for two months of consistent support.",
    details:
      "Includes powder, cold-pressed coconut oil and herbal capsules to support digestion, immunity, and sugar balance.",
    available: "Limited Stock",
  },
  {
    id: "balance-pack",
    src: "/assets/8.png",
    alt: "Swathi’s product bundles with pouches, coconut oil bottle, and soap bars",
    title: "Diabetic 1kg",
    subtitle: "3 Month Supply",
    price: "₹3,000 / 3 Months",
    packSize: "1kg",
    caption: "Complete 3-month wellness package for lasting results.",
    details:
      "A curated wellness bundle with powder, oil and herbal extras to support overall balance and energy.",
    available: "In Stock",
  },
  {
    id: "trial-pack",
    src: "/assets/12.png",
    alt: "Swathi’s diabetic oil bottle with premium label",
    title: "Diabetic Oil",
    subtitle: "500 ml",
    price: "₹399 / 500 ml",
    packSize: "500 ml",
    caption: "Natural diabetic oil for easy daily support in a convenient 500 ml bottle.",
    details:
      "Available in 500 ml for ₹399 and large 1000 ltr refills for ₹930. Use daily as directed for natural diabetic wellness support.",
    fit: "contain",
    available: "In Stock",
  },
];

export const trustBadges = [
  { icon: "✅", label: "100% Natural" },
  { icon: "🚫", label: "No Preservatives" },
  { icon: "🏭", label: "Made in India" },
  { icon: "🌿", label: "Chemical Free" },
];

export const quantityOptions = [
  { value: "1", label: "1 Pack" },
  { value: "2", label: "2 Packs (Save more)" },
  { value: "3", label: "3 Packs (Best Value)" },
];

export const stateOptions = [
  "Telangana",
  "Andhra Pradesh",
  "Karnataka",
  "Tamil Nadu",
  "Maharashtra",
  "Other",
];
